import { toArray } from 'underscore';

const isLocalOrDev = () => __ENV__ === 'local' || __ENV__ === 'development';

export const PAGE_DATA = {
    HOME: {
        name: 'home',
        path: '/',
        title: 'meta-default-title',
        description: 'meta-default-description',
    },

    // new pages

    XS1: {
        name: 'xs1',
        path: '/xs1',
        title: 'xp1-product-general-page-title',
        description: 'xp1-product-general-page-descr',
        postLaunch: true,
    },

    XP1: {
        name: 'xp1',
        path: '/xp1',
        title: 'xp1-product-general-page-title',
        description: 'xp1-product-general-page-descr',
    },

    OXEFIT: {
        name: 'oxefit',
        path: '/oxefit',
        title: 'oxefit-general-page-title',
        description: 'oxefit-general-page-descr',
    },

    OXELEAD: {
        name: 'oxelead',
        path: '/oxelead',
        title: 'oxelead-general-page-title',
        description: 'oxelead-general-page-descr',
    },

    OXELIFE: {
        name: 'oxelife',
        path: '/oxelife',
        title: 'oxelife-general-page-title',
        description: 'oxelife-general-page-descr',
    },

    PREORDER: {
        name: 'preorder',
        path: '/preorder',
        title: 'payment-general-page-title',
        description: 'payment-general-page-descr',
    },

    SHOP: {
        name: 'shop',
        path: '/shop',
        postLaunch: true,
    },

    // SHOP_XS1: {
    //     name: 'configure',
    //     path: '/shop(/)(xs1)',
    // },

    // SHOP_XP1: {
    //     name: 'configure',
    //     path: '/shop(/)(xp1)',
    // },

    CONFIGURE: {
        name: 'configure',
        path: '/configure(/)(:product)',

        XS1: '/configure/xs1',
        XP1: '/configure/xp1',

        postLaunch: true,
    },

    // CART: {
    //     name: 'cart',
    //     path: '/cart',
    //     postLaunch: true,
    // },

    ACCOUNT: {
        name: 'account',
        path: '/account',
        // postLaunch: isLocalOrDev() ? false : true,
    },
    SIGN_IN: {
        name: 'signin-oxefit',
        path: '/signin-oxefit',
        // postLaunch: isLocalOrDev() ? false : true,
    },

    // phase 1 pages
    INFORMATION: {
        name: 'information',
        path: '/information',
    },

    LEADERSHIP: {
        name: 'leadership',
        path: '/leadership',
    },

    PRESS: {
        name: 'press',
        menuName: 'News',
        path: '/news',
    },

    INVESTORS: {
        name: 'investors',
        menuName: 'Media / IR',
        path: '/media-ir',
    },

    CAREERS: {
        name: 'careers',
        path: '/careers',
    },

    CONTACT: {
        name: 'contact',
        menuName: 'Contact',
        path: '/contact',
    },

    // legal pages
    COOKIEPOLICY: {
        name: 'cookie-policy',
        menuName: 'Cookie Policy',
        path: '/cookie-policy',
    },
    PRIVACYPOLICY: {
        name: 'privacy-policy',
        menuName: 'Privacy Policy',
        path: '/privacy-policy',
    },
    // NOW COMBINED INTO TERMS OF SALE.
    // TERMSOFSERVICE: {
    //     name: 'terms-of-service',
    //     menuName: 'Terms of Service',
    //     path: '/terms-of-service',
    // },
    TERMSOFSALE: {
        name: 'terms-of-sale',
        menuName: 'Terms of Sale',
        path: '/terms-of-sale',
    },
    WARRANTY: {
        name: 'warranty',
        menuName: 'Warranty',
        path: '/warranty',
    },
    SCHEDULE_DEMO: {
        name: 'schedule-demo',
        XS1: 'https://demo.oxefit.com/virtual-demo-booking',
    },
};

export const PAGES = toArray(PAGE_DATA);
